<script>
    import { ToggleBox } from "./index";
    import cssVars from "svelte-css-vars";
    import { Field } from "svantic";

    export let cols = 5;
    export let rows = 5;
    export let maxSelectedItems = rows * cols;
    let isMaxSelected = false
    
    export let hasControls = true
    export let selectedNumbers = new Set();

    const Fields = [];

   

    let default_css_vars = {
        itemSize: "36px",
        borderColor: "#2196F3",
        borderRadius: "0px",
        backgroundColor: "transparent",
        backgroundColorChecked: "#ccc",
        backgroundColorDisabled: "#ccc",
        textColor: "#bbb",
        textColorChecked: "#080808",
        textColorDisabled: "#ececec",
    };

    export let itemSize = default_css_vars.itemSize;
    export let borderColor = default_css_vars.borderColor;
    export let borderRadius = default_css_vars.borderRadius;
    export let backgroundColor = default_css_vars.backgroundColor;
    export let backgroundColorChecked = default_css_vars.backgroundColorChecked;
    export let backgroundColorDisabled = default_css_vars.backgroundColorDisabled;
    export let textColor = default_css_vars.textColor;
    export let textColorChecked = default_css_vars.textColorChecked;
    export let textColorDisabled = default_css_vars.textColorDisabled;

    export let labeled = true;

    $: css_vars = {
        ...default_css_vars,
        ...{
            itemSize,
            borderColor,
            backgroundColor,
            backgroundColorChecked,
            backgroundColorDisabled,
            borderRadius,
            textColor,
            textColorChecked,
            textColorDisabled,
        },
    };

    const initializeArrayWithRange = (end, start = 0, step = 1) =>
        Array.from(
            { length: Math.ceil((end - start + 1) / step) },
            (_, i) => i * step + start
        );

    $: arr_rows = initializeArrayWithRange(rows, 1);
    $: arr_cols = initializeArrayWithRange(cols, 1);

    const changeHandler = (event) => {
        if (event.detail.checked === true) {
            if (selectedNumbers.size < maxSelectedItems) {
                selectedNumbers.add(event.detail.data.value);

                selectedNumbers = selectedNumbers;
            }
        } else if (
            selectedNumbers.has(event.detail.data.value)
        ) {
            selectedNumbers.delete(event.detail.data.value);

            selectedNumbers = selectedNumbers;
        }

        console.log("ToggleBoxGrid changeHandler, selectedNumbers.size: ", selectedNumbers.size)
    };

    export const reset = () => {
        //uncheck all fields
        Fields.forEach((element) => {
            element.checked = false;
            element.disabled = false;
        });

        selectedNumbers = new Set();
    };


    const disableUncheckedFields = () =>{
        Fields.forEach((element) => {
            if(!element.checked)
                element.disabled = true;
        });
    }

    const enableAllFields = () =>{
        Fields.forEach((element) => {
                element.disabled = false;
        });
    }

    $: {
        if ( selectedNumbers.size > maxSelectedItems) {
            reset();
        }
        else if(selectedNumbers.size == maxSelectedItems && isMaxSelected == false){
            isMaxSelected = true
        }
        else if (selectedNumbers.size < maxSelectedItems && isMaxSelected == true){
            isMaxSelected = false
        }
    }

    $: if(isMaxSelected == true){
        disableUncheckedFields()
    }else {
        enableAllFields()
    }

    // $:       console.log("ToggleBoxGrid selectedNumbers: ", [... selectedNumbers])
</script>

<div use:cssVars={css_vars}>
    {#each arr_rows as row, y}
        <div class="flex-container">
            {#each arr_cols as number, x}
                <div class="flex-item">
                    <ToggleBox
                        bind:this={Fields[y * arr_cols[arr_cols.length - 1] + number - 1 ]}
                        {...css_vars}
                        data={{
                            tileX: number,
                            tilesY: row,
                            value: y * arr_cols[arr_cols.length - 1] + number,
                        }}
                        label={labeled
                            ? y * arr_cols[arr_cols.length - 1] + number
                            : ""}
                        on:change={changeHandler} />
                </div>
            {/each}
        </div>
    {/each}

    {#if hasControls}
        <div >
            <button on:click={reset}>reset</button>
        </div>
    {/if}
   
</div>

<style>
    .flex-container {
        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;
    }

    .flex-item {
        flex: 0 0 auto;
        padding: 0px;
        margin: 2px;
        width: var(--itemSize);
        height: var(--itemSize);
        outline: 1px solid #696969;
      /*  background-color: #ececec;*/
    }
    .flex-item:hover {
       /* background-color: var(--backgroundColor);*/
    }
</style>
